/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-title-font-style',
  templateUrl: './theme-option-tooltips-title-font-style.component.html',
  styleUrls: ['./theme-option-tooltips-title-font-style.component.css']
})
export class ThemeOptionTooltipsTitleFontStyleComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_titleFontStyle';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_titleFontStyle', value);
  }

}
